module.exports = "<div class=\"modal modal-fnji-weixin\" v-show=\"value\" @click=\"hide()\">\r\n    <div class=\"modal-dialog\">\r\n        <div class=\"modal-content\">\r\n            <i class=\"u-icon u-icon-fnji-weixin\"></i>\r\n        </div>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/mac/001.code/xbigger-web/xbigger/fnjinew/build-v2/node_modules/text-loader!../common/modal/fnji-weixin.html
// module id = 52
// module chunks = 0 1 2 3